var exports = {
  "k": "GuildDetachedBanner.module__container___LUktbl",
  "v": "GuildDetachedBanner.module__banner___LUktbl",
};

module.exports = exports;
